import React, {
  FormEventHandler,
  ForwardedRef,
  ReactElement,
  forwardRef,
  Ref,
} from 'react';
import PolarisForm from '@amzn/awsui-components-react-v3/polaris/form';
import RjsfForm, { FormProps as RjsfFormProps, withTheme } from '@rjsf/core';
import { RJSFSchema, StrictRJSFSchema, FormContextType } from '@rjsf/utils';

import { AwsUIFormProps } from './types';
import { Theme } from './Theme';

/**
 * The traditional RJSF export using the withTheme HOC.
 */
const AwsUiForm = withTheme(Theme) as <
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any
>(
  props: RjsfFormProps<T, S, F> & { ref?: Ref<RjsfForm<T, S, F>> },
) => ReactElement;

// -- Internal Form Wrapper --
function BasePolarisForm<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any
>(
  props: AwsUIFormProps<T, S, F>,
  ref: ForwardedRef<RjsfForm<T, S, F>>,
): ReactElement {
  const { children, ...restProps } = props;

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    // @ts-ignore - ref.current has onSubmit in RJSF
    ref?.current?.onSubmit?.(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PolarisForm actions={children} {...restProps}>
        <AwsUiForm<T, S, F> {...restProps} tagName="div" ref={ref} />
      </PolarisForm>
    </form>
  );
}

export const Form = forwardRef(BasePolarisForm) as <
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any
>(
  props: AwsUIFormProps<T, S, F> & {
    ref?: ForwardedRef<RjsfForm<T, S, F>>;
  },
) => ReactElement;
